import React from 'react';

const Menu = (props) => {
    const {showMenu} = props;
    return (
        <div className={showMenu ? "menu-container show" : "menu-container"}>
            <ul>
                <li><a href='#intro-container'>HOME</a></li>
                <li><a href='#about-container'>ABOUT</a></li>
                <li><a href='#skill-container'>SKILLS</a></li>
                <li>CONTACT</li>
            </ul>
        </div>
    );
};

export default Menu;